var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!!_vm.schema.contentOfDocument)?_c('div',{staticClass:"mt-2"},[_c('w-wysiwyg',{attrs:{"model":_vm.schema.contentOfDocument,"config":_vm.contentConfig}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }